<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_5">Contents</h2>
<p class="firstcenter"><a href="#/Text/intro#_idTextAnchor000">Introduction</a></p>
<p class="firstcenter"><br/></p>
<p class="firstcenter"><a href="#/Text/sec1"><b>SECTION 1: TOOLS FOR LOVING<br/>
  PEOPLE WITH ADDICTION</b></a></p>
<p class="firstcenter"><a href="#/Text/ch1#_idTextAnchor005">1 Responding to Addiction</a></p>
<p class="firstcenter"><span href="#/Text/ch2#_idTextAnchor013" title="Link target outside of Sample">2 The Intervention</span></p>
<p class="firstcenter"><span href="#/Text/ch3#_idTextAnchor023" title="Link target outside of Sample">3 Myths About Addiction</span></p>
<p class="firstcenter"><br/></p>
<p class="firstcenter"><span href="#/Text/sec2" title="Link target outside of Sample"><b>SECTION 2: TOOLS FOR CREATING<br/>
  A RECOVERY-FRIENDLY CHURCH</b></span></p>
<p class="firstcenter"><span href="#/Text/ch4#_idTextAnchor043" title="Link target outside of Sample">4 Cultivating a Culture of Long-Term Sobriety</span></p>
<p class="firstcenter"><span href="#/Text/ch5#_idTextAnchor077" title="Link target outside of Sample">5 Ending the Shame</span></p>
<p class="firstcenter"><span href="#/Text/ch6#_idTextAnchor101" title="Link target outside of Sample">6 The Practice of Attentive Listening</span></p>
<p class="firstcenter"><span href="#/Text/ch7#_idTextAnchor116" title="Link target outside of Sample">7 The Practice of Healing</span></p>
<p class="firstcenter"><span href="#/Text/conclusion#_idTextAnchor124" title="Link target outside of Sample">Conclusion</span></p>
<p class="firstcenter"><span href="#/Text/acknowledgments#_idTextAnchor130" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstcenter"><span href="#/Text/app#_idTextAnchor131" title="Link target outside of Sample">Appendix: Resources for Ministry</span></p>
<p class="firstcenter"><span href="#/Text/notes#_idTextAnchor133" title="Link target outside of Sample">Notes</span></p>
<p class="firstcenter"><span href="#/Text/praise#_idTextAnchor256" title="Link target outside of Sample">Praise for <i>The Recovery-Minded Church</i></span></p>
<p class="firstcenter"><span href="#/Text/authors#_idTextAnchor257" title="Link target outside of Sample">About the Authors</span></p>
<p class="firstcenter"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstcenter"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0fa3ba2e